$(document).ready(function () {

    $('.hotspot__product-button').click(function () {
        $(this).find('.sr-btn__txt').hide(0).delay(1500).show(0);
        $(this).find('.loading-overlay').show(0).delay(1500).hide(0);
        data = {
            "id": $(this).data('id'),
            "quantity": 1
        }

        const self = this;
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                window.theme.actions.openCartDrawer(self);
            }
        });
    });


    $('button.hotspot__target').click(function () {
        $(this).parent().addClass('is-active');
        if ($(window).width() < 768) {
            $(this).parents('.piq-banner').find('.hotspot__mobile').addClass('is-active');
            $('body').addClass('hotspot__open');
            $('html').addClass('lock');
            $(this).parents('.piq-banner').find('.hotspot__mobile')?.focus();
        } else {
            var hotspot = $(this).parent().find(".hotspot__content");
            hotspot?.focus();
        }
    });
});

$(document).mouseup(function (e) {
    var hotspot = $(".hotspot__content");
    if (hotspot.parent().hasClass('is-active')) {
        if (!hotspot.is(e.target) && hotspot.has(e.target).length === 0) {
            hotspot.parent().removeClass('is-active');
        }
        var hotspot_mobile = $(".hotspot__mobile");
        if (!hotspot_mobile.is(e.target) && hotspot_mobile.has(e.target).length === 0) {
            hotspot_mobile.removeClass('is-active');
            $('body').removeClass('hotspot__open');
            $('html').removeClass('lock');
            var x = window.scrollX, y = window.scrollY;
            $(".hotspot__target")?.focus();
            window.scrollTo(x, y);
        }
    }
});


$(window).scroll(function () {
    var target = '.piq-banner__button-wrapper';
    if ($(target).length > 0) {
        if ($(window).scrollTop() >= $(target).offset().top + $(target).outerHeight() - 164) {
            $(target).addClass('sticky');
        } else {
            $(target).removeClass('sticky');
        }
    }
});